import React, { useState, useEffect } from "react";
import axios from "axios";
import LeftCard from "../../components/Consultant/Dashboard/LeftCard";
import Table from "../../components/Consultant/Dashboard/Table";
import Topdiv from "../../components/Consultant/Dashboard/TopCard";
import Loader from "../../components/Global/Loader";


function MainConsultantDashBoard() {
  const [consultantData, setConsultantData] = useState(null);
  const [applications, setApplications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const token = localStorage.getItem("token");

        // Fetch consultant profile and applications in parallel
        const [consultantResponse, applicationsResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/consultant`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/application`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        // Set state with fetched data
        setConsultantData(consultantResponse.data.data);
        setApplications(applicationsResponse.data.data.applications);
      } catch (err) {
        // console.error("Error fetching data:", err);
        setError("Failed to load dashboard data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <div id="main-content" className="relative pl-36 pr-12 mt-16 w-full py-8 bg-[#f4f8fb]">
      {isLoading && <Loader />}
      {error && <p className="text-center text-red-600">{error}</p>}

      {!isLoading && !error && (
        <>
          <Topdiv />
          <div className="flex flex-wrap space-x-6">
            <Table applications={applications} />
            <LeftCard profileData={consultantData} />
          </div>
        </>
      )}
    </div>
  );
}

export default MainConsultantDashBoard;

